import "./pubs-page.css"
import { useEffect, useState } from "react";
import { getBibliography } from "../publications";
import { Entry, parse } from "@retorquere/bibtex-parser";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import rehypeRaw from 'rehype-raw'
import { type } from "os";

interface PubSection {
  title : string,
  bib : string
}

async function getPubsString(bibfile : string) {

    let filename = bibfile;

    if(!bibfile.endsWith(".bib"))
      filename += ".bib"



    const text = await fetch(filename)
    .then( (response) =>  { return response.text() } );


    return text
}


const toYearMap = (refs : string[], entries : Map<string, Entry>) => {
    let map : Map<number, string[]> = new Map()


    for (let i = 0; i < refs.length; i++) {
      const element = refs[i];
      const ref = element[0];
      const id  = element[1];
      const entry = entries.get(id);
      let year = parseInt(entry!.fields["year"][0]);
      let pdf = entry?.fields["pdf"];
      let m = map.get(year)

      // Update to add PDF
      let ref_string = ref + (pdf == undefined ? "" : `[PDF](${pdf![0]})`)

      // Update to turn doi into URL
      let d_field = entry?.fields["doi"]
      if(d_field !== undefined){ 
        let doi = "https://doi.org/" + d_field[0];
        ref_string = ref_string.replace(doi, `[${doi}](${doi})`)
      }

      if( m === undefined)
          map.set(year, [ref_string])
      else
        m.push(ref_string)
      
    }

    return map;
}

const bibToMap = ( entries : Entry[]) => {
    let map : Map<string, Entry>= new Map()
    
    for (let i = 0; i < entries.length; i++) {
      const element = entries[i];
      map.set(element.key, element);
    }

    return map;
} 

interface BibSection {
  title : string,
  references : Map<number, string[]>
}

const BibSectionComponent = ({title, references} : BibSection ) => {


  let l : any = []


  references.forEach((refs, year) => {
    l.push(
      <div key={`${title}_${year}_section`}>
      <h3>{year}</h3>
      <hr />
      <ul>
        {refs.map((el, i) => <li key={`pub_${i}`}><ReactMarkdown  rehypePlugins={[rehypeRaw]}>{el}</ReactMarkdown></li>)}
      </ul>
      </div>
    )

  });


  return  <div key={`${title}_section`}>
  <h3>{title}</h3>
  <div className="pubs">
    {l}
  </div>
</div>
}



const PubsPage = (props : { title : string, sections : PubSection[], format : string } ) => {

  const [bib, setBib] = useState<BibSection[]>([])

  useEffect(() => {

    props.sections.forEach( (section) => {
      getPubsString(section.bib).then( (text) => {

      const bibJSON = parse(text);
      const b = toYearMap(getBibliography(text, props.format), bibToMap(bibJSON.entries))

      
      setBib( (prev) => 
        prev.some( (el) => el.title === section.title) ? prev : [...prev, {title : section.title, references : b}] )
      
      });
    });

  }, [props.sections]);


  return  <div className="body-block">
  <h1>{props.title}</h1>
  {bib?.map( (section, i) => <BibSectionComponent key={`bib_section_${i}`} title={section.title} references={section.references} />)}
  </div>

}

export { PubsPage };
export type { PubSection }